<template>
  <div class="sky-hc-right-content">
    <slot></slot>
  </div>
</template>
<script>
export default {
  name: 'RightContent'
}
</script>
<style lang="scss" scoped>
.sky-hc-right-content {
  width: calc(100% - 252px);
  min-height: calc(100vh - 60px);
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.1);
}
</style>
